<div *ngIf="passwordSecurity" class="form-content-outer">

  <div class="form-outer">
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <!-- <h2 class="first"></h2> -->
      <div class="col">
        <div class="form__group">
          <label class="form__label">Current Password</label>
          <input class="form__control" formControlName="oldPassword" type="password" pInputText maxlength="25">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.oldPassword, 'required')">{{validationMessages.oldPassword.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.oldPassword, 'validStrongPassword')">{{validationMessages.oldPassword.invalid}}</span>
        </div>

        <div class="form__password-block"
          [ngClass]="{'weak': passwordStrength === 'Weak', 'medium': passwordStrength === 'Medium', 'strong': passwordStrength === 'Strong'}">

          <div class="form__group">
            <label class="form__label">New Password</label>
            <p-password class="form__p-password" [feedback]="false" formControlName="newPassword" maxlength="25"
              [toggleMask]="true" (input)="onPasswordInput()"> </p-password>
          </div>

          <div class="form__password-strength">
            <div class="form__strengths weak"><span>Weak</span></div>
            <div class="form__strengths medium"><span>Medium</span></div>
            <div class="form__strengths strong"><span>Strong</span></div>
          </div>
          <div class="info-box">
            <h3 class="info-box__title">
              <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.5 0C4.532 0 0.5 4.032 0.5 9C0.5 13.968 4.532 18 9.5 18C14.468 18 18.5 13.968 18.5 9C18.5 4.032 14.468 0 9.5 0ZM10.4 13.5H8.6V8.1H10.4V13.5ZM10.4 6.3H8.6V4.5H10.4V6.3Z"
                  fill="#666666" />
              </svg>
              Your password must include:
            </h3>

            <ul class="info-box__list">
              <li class="info-box__item" *ngFor="let rule of validationRules">
                <svg *ngIf="!this[rule.key]" class="info-box__no" width="13" height="12" viewBox="0 0 13 12" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 11L1.5 1M11.5 1L1.5 11" stroke="#FF1F1F" stroke-width="2" stroke-linecap="round" />
                </svg>
                <svg *ngIf="this[rule.key]" class="info-box__yes" width="15" height="14" viewBox="0 0 15 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 8.81818C1.5 8.81818 2.78571 8.81818 4.5 12C4.5 12 9.26486 3.66636 13.5 2"
                    stroke="#9CAF2E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span [innerHTML]="rule.message"></span>
              </li>
            </ul>
          </div>
        </div>

        <div class="form__group">
          <label class="form__label">Confirm New Password</label>
          <input class="form__control" formControlName="confirmPassword" type="password" pInputText
            appConfirmEqualValidator='newPassword' maxlength="25">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.confirmPassword, 'required')">{{validationMessages.confirmPassword.required}}</span>
          <span class="invalid-feedback"
            *ngIf="form.hasError('validPasswordMatch')">{{validationMessages.confirmPassword.validPasswordMatch}}</span>
        </div>

      </div>

      <div class="set-custom-date-btn">
        <button class="btn btn--primary">Update Password</button>
      </div>
    </form>
  </div>

  <div class="reminder" *ngIf="reminder >=0 && passwordExpiryNotification" style="color: red; font-style: italic;">
    {{passwordReminder}}
  </div>
</div>

<div *ngIf="!passwordSecurity" class="form-content-outer">
  <div class="form-outer">
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <!-- <h2 class="first"></h2> -->
      <div class="col">
        <div class="form__group">
          <label class="form__label">Current Password</label>
          <input class="form__control" formControlName="oldPassword" type="password" pInputText maxlength="25">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.oldPassword, 'required')">{{validationMessages.oldPassword.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.oldPassword, 'validStrongPassword')">{{validationMessages.oldPassword.invalid}}</span>
        </div>
      </div>
      <div class="col">
        <div class="form__group">
          <label class="form__label">New Password</label>
          <input class="form__control" formControlName="newPassword" type="password" pInputText maxlength="25">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.newPassword, 'required')">{{validationMessages.newPassword.required}}</span>
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.newPassword, 'validStrongPassword')">{{validationMessages.newPassword.invalid}}</span>

          <a href="javascript:void(0)" class="pass-info">
            <i class="info-new"></i>

            <span class="password-info">
              Password must contain minimum 8 characters length,<br> at least one upper case letter,<br> one lower case
              letter, <br>one special character, <br>one numeric character.
            </span>
          </a>
        </div>

        <div class="form__group">
          <label class="form__label">Confirm New Password</label>
          <input class="form__control" formControlName="confirmPassword" type="password" pInputText
            appConfirmEqualValidator='newPassword' maxlength="25">
          <span class="invalid-feedback"
            *ngIf="hasError(formFields.confirmPassword, 'required')">{{validationMessages.confirmPassword.required}}</span>
          <!--<span class="invalid-feedback" *ngIf="hasError(formFields.confirmPassword, 'validStrongPassword')"
                 >{{validationMessages.confirmPassword.invalid}}</span><br />-->
          <span class="invalid-feedback"
            *ngIf="form.hasError('validPasswordMatch')">{{validationMessages.confirmPassword.validPasswordMatch}}</span>
        </div>
      </div>

      <div class="set-custom-date-btn">
        <button class="btn btn--primary">Update</button>
        <button class="btn btn--secondary" (click)="onCancel()">Cancel</button>
      </div>
    </form>
  </div>

  <div class="reminder" *ngIf="reminder >=0 && passwordExpiryNotification" style="color: red; font-style: italic;">
    {{passwordReminder}}
  </div>
</div>
